import { useRequest } from '@mgm/common/lib';
import { TAxiosError } from '@mgm/common/types';
import { CONTROLLERS } from '../../utils/enums';
import { TGetLocationMetrics, TIntegrateReq, TLocationsMappingReq } from '../../types/requests';
import { BASE_URL } from '../../../config';
import { getIdToken } from '../../utils/helpers';

export function DorController() {
  const {
    axiosRequest,
    initRequestOptions,
  } = useRequest(BASE_URL);

  const controllerName = CONTROLLERS.INTEGRATIONS.DOR;

  const integrate = <T>(data: TIntegrateReq): Promise<T | { success: boolean; error: TAxiosError }> => {
    const requestOptions = initRequestOptions(data, { method: 'POST', authToken: getIdToken() });

    return axiosRequest(`${controllerName}/integrate`, requestOptions);
  };

  const getDorIntegration = <T>(data: { shopName: string }): Promise<T | { success: boolean; error: TAxiosError }> => {
    const requestOptions = initRequestOptions(data, { method: 'POST', authToken: getIdToken() });

    return axiosRequest(`${controllerName}/get`, requestOptions);
  };

  const getDorLocations = <T>(data: { shopName: string }): Promise<T | { success: boolean; error: TAxiosError }> => {
    const requestOptions = initRequestOptions(data, { method: 'POST', authToken: getIdToken() });

    return axiosRequest(`${controllerName}/get_locations`, requestOptions);
  };

  const setLocationsMapping = <T>(data: TLocationsMappingReq): Promise<T | { success: boolean; error: TAxiosError }> => {
    const requestOptions = initRequestOptions(data, { method: 'POST', authToken: getIdToken() });

    return axiosRequest(`${controllerName}/set_locations_mapping`, requestOptions);
  };

  const getLocationMetrics = <T>(data: TGetLocationMetrics): Promise<T | { success: boolean; error: TAxiosError }> => {
    const requestOptions = initRequestOptions(data, { method: 'POST', authToken: getIdToken() });

    return axiosRequest(`${controllerName}/get_location_metrics`, requestOptions);
  };

  return {
    integrate,
    getDorIntegration,
    getDorLocations,
    setLocationsMapping,
    getLocationMetrics,
  };
}
